import React, { HTMLAttributes } from 'react';

const DocumentDownload = ({
  className,
}: HTMLAttributes<HTMLElement>): JSX.Element => (
  <svg
    className={className}
    xmlns="http://www.w3.org/2000/svg"
    viewBox="0 0 40 40"
  >
    <circle cx="50%" cy="50%" r="50%" fill="#fff" />
    <path
      d="M27.069 19.069A7.077 7.077 0 0 0 20 12a7.077 7.077 0 0 0-7.068 7.069.42.42 0 0 0 .838 0 6.237 6.237 0 0 1 6.23-6.23 6.237 6.237 0 0 1 6.23 6.23 6.237 6.237 0 0 1-6.23 6.23h-.727l1.04-1.165a.42.42 0 0 0-.625-.558L18.2 25.24a.717.717 0 0 0 0 .956l1.487 1.664a.418.418 0 0 0 .592.033.42.42 0 0 0 .033-.592l-1.04-1.164H20a7.077 7.077 0 0 0 7.069-7.068Z"
      fill="#000"
    />
  </svg>
);

export default DocumentDownload;
